angular.module('huni').constant('cfg', {
    url:  '/vlab',
    solr: '/solr',
});
